module.exports = __webpack_public_path__ + "img/hexagon_3.84ce6f88.png";